import React from "react";
import {
  Box,
  VStack,
  HStack,
  useBreakpointValue,
} from "@chakra-ui/react";
import { differenceInDays, eachDayOfInterval, eachWeekOfInterval, eachMonthOfInterval, format } from "date-fns";

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  TimeScale,
  TimeSeriesScale,
} from 'chart.js';
import 'chartjs-adapter-date-fns';
import {Bar} from "react-chartjs-2"
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  TimeScale
);

const GanttChart = ({ events }) => {
  // Parse dates
  const parsedEvents = events.map((e) => ({
    ...e,
    startDate: new Date(e.start),
    endDate: new Date(e.end),
  }));

  // todayLine plugin
  const todayLine = {
    id: 'todayLine',
    afterDatasetsDraw(chart, args, pluginOptions) {
      const {ctx, data, chartArea: {top, bottom, left, right}, scales: {x, y}} = chart;

      ctx.save();

      ctx.beginPath();
      ctx.lineWidth = 3;
      ctx.strokeStyle = 'rgba(255, 99, 132, 0.5)';
      ctx.setLineDash([6, 6]);
      ctx.moveTo(x.getPixelForValue(new Date()), top);
      ctx.lineTo(x.getPixelForValue(new Date()), bottom);
      ctx.stroke();
    }
  }

  const options = {
    responsive: true,
    plugins: [todayLine],   
    indexAxis: 'y',
    scales: {
      x: {
        type: 'time',
        time: {
          unit: 'day'
        },
        min: "2025-04-01"
      }
    }
  }  

  const data = {
    // labels,
    datasets: [
      {
        label: 'Dataset 1',
        data: [
          // {x: "2025-04-01" , y: "Impianti"}
          {x: ["2025-04-01", "2025-04-15"], y: "Impianti"},
          {y: "Pavimentazione", x: ["2025-04-14", "2025-05-04"] },
          {y: "Stucco", x: ["2025-04-20", "2025-04-24"] },
          {y: "Pulizia", x: ["2025-05-04", "2025-05-09"] }
        ], 
        // backgroundColor: 'rgba(255, 99, 132, 0.5)',
      },
    ],
  };

  return (
    <Bar options={options} data={data} />
  );
};

export default GanttChart;